<template>
    <div class="lite-task">
        <!-- 加载所有任务 -->
        <div class="lite-tasks-loading" v-show="loadingAllTask"></div>
        <!-- 无任务提示 -->
        <div class="task-none" v-if="$store.state.tasks.length == 0 && !loadingAllTask">
            <img src="../../assets/images/task-icon/no_task_bg.png" draggable="false" />
            <div class="task-none-title">{{$t('language.taskList.noTasks')}}</div>
            <div class="task-none-desc">{{$t('language.taskList.noTasksTip')}}</div>
        </div>
        <!-- 任务分类 -->
        <div class="task-nav" v-if="$store.state.tasks.length > 0">
            <div class="task-tabs">
                <div :class="'task-tab' + (activeName=='all'?' select':'')" @click="selectTab('all')">
                    <el-badge :value="0" :max="99" class="lite_task_add_count" :hidden="true">
                        <span>{{$t('language.filters.taskList.type.all')}}</span>
                    </el-badge>
                </div>
                <div v-if="copyTaskCount" :class="'task-tab' + (activeName=='copy'?' select':'')" @click="selectTab('copy')">
                    <el-badge :value="$store.state.liteFileTaskCountCopy" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountCopy<1">
                        <span>{{$t('language.filters.taskList.type.copy')}}</span>
                    </el-badge>
                </div>
                <div v-if="tranTaskCount" :class="'task-tab' + (activeName=='tran'?' select':'')" @click="selectTab('tran')">
                    <el-badge :value="$store.state.liteFileTaskCountTran" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountTran<1">
                        <span>{{$t('language.filters.taskList.type.transfer')}}</span>
                    </el-badge>
                </div>
                <div v-if="syncTaskCount" :class="'task-tab' + (activeName=='sync'?' select':'')" @click="selectTab('sync')">
                    <el-badge :value="$store.state.liteFileTaskCountSync" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountSync<1">
                        <span>{{$t('language.filters.taskList.type.sync')}}</span>
                    </el-badge>
                </div>
                <div v-if="backupTaskCount" :class="'task-tab' + (activeName=='backup'?' select':'')" @click="selectTab('backup')">
                    <el-badge :value="$store.state.liteFileTaskCountBackup" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountBackup<1">
                        <span>{{$t('language.filters.taskList.type.backup')}}</span>
                    </el-badge>
                </div>
                <div v-if="restoreTaskCount" :class="'task-tab' + (activeName=='restore'?' select':'')" @click="selectTab('restore')">
                    <el-badge :value="$store.state.liteFileTaskCountRestore" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountRestore<1">
                        <span>{{$t('language.filters.taskList.type.restore')}}</span>
                    </el-badge>
                </div>
                <div v-if="websiteTaskCount" :class="'task-tab' + (activeName=='website'?' select':'')" @click="selectTab('website')">
                    <el-badge :value="$store.state.liteFileTaskCountWebsite" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountWebsite<1">
                        <span>{{$t('language.leftBanner.liteWebsite')}}</span>
                    </el-badge>
                </div>
                <div v-if="cloneTaskCount" :class="'task-tab' + (activeName=='clone'?' select':'')" @click="selectTab('clone')">
                    <el-badge :value="$store.state.liteFileTaskCountClone" :max="99" class="lite_task_add_count" :hidden="$store.state.liteFileTaskCountClone<1">
                        <span>{{$t('language.leftBanner.liteClone')}}</span>
                    </el-badge>
                </div>
            </div>
            <!-- 右边导航 -->
            <div class="task-nav-right">
                <!-- 删除选中任务 -->
                <div class="delete-select-tasks" v-if="activeView=='list' && multipleSelection.length>0" @click="deleteTasks()"></div>
                <!-- 筛选任务状态 -->
                <el-tooltip effect="light" placement="bottom">
                    <template slot="content">
                        <div><el-checkbox v-model="taskStatusAll"><span class="filter-status">{{$t('language.common.selectAll')}}</span></el-checkbox></div>
                        <div class="filter-status-space"></div>
                        <div><el-checkbox v-model="taskStatus.create"><span class="filter-status">{{ $t('language.popup.createTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.pending"><span class="filter-status">{{ $t('language.popup.pendingTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.running"><span class="filter-status">{{ $t('language.popup.runningTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.cancelled"><span class="filter-status">{{ $t('language.popup.cancelledTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.completed"><span class="filter-status">{{ $t('language.popup.completedTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.failed"><span class="filter-status">{{ $t('language.popup.failedTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.warn"><span class="filter-status">{{ $t('language.popup.warnTaskStatus') }}</span></el-checkbox></div>
                        <div><el-checkbox v-model="taskStatus.error"><span class="filter-status">{{ $t('language.popup.errorTaskStatus') }}</span></el-checkbox></div>
                    </template>
                    <div class="task-filter-status">{{$t('language.common.status')}}</div>
                </el-tooltip>
                <!-- 任务显示方式 -->
                <div class="task-nav-view">
                    <div :class="'task-nav-box' + (activeView=='box'?' select':'')" @click="selectView('box')"></div>
                    <div :class="'task-nav-list' + (activeView=='list'?' select':'')" @click="selectView('list')"></div>
                </div>
            </div>
        </div>
        <!-- 任务列表 -->
        <div class="task-items myscroll lite-task-box" v-if="$store.state.tasks.length > 0">
            <!-- 无任务 -->
            <div class="task-none" v-if="filterTasks.length == 0">
                <img src="../../assets/images/task-icon/no_task_bg.png" draggable="false" />
                <div class="task-none-title">{{$t('language.taskList.noTasks')}}</div>
                <div class="task-none-desc">{{$t('language.taskList.noTasksTip')}}</div>
            </div>
            <!-- 单个任务: 列表模式 -->
            <el-table v-if="activeView=='list' && filterTasks.length>0" class="task-list" :data="filterTasks" height="300px" @selection-change="handleSelectionChange">
                <!-- 复选框 -->
                <el-table-column type="selection" width="42" align="center" header-align="center"></el-table-column>
                <!-- 任务名称栏 -->
                <el-table-column :label="$t('language.common.taskName')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="row-task-name">
                            <!-- 任务类型图标 -->
                            <div v-if="scope.row.type == 'copy'" class="cloudTransfer-black"></div>
                            <div v-if="scope.row.type == 'tran'" class="cloudTransfer-black"></div>
                            <div v-if="scope.row.type == 'sync'" class="cloudsync-black"></div>
                            <div v-if="scope.row.type == 'backup'" class="cloudbackup-black"></div>
                            <div v-if="scope.row.type == 'restore'" class="restoreTask-black"></div>
                            <div v-if="scope.row.type == 'website'" class="liteWebsite-black"></div>
                            <div v-if="scope.row.type == 'clone'" class="liteClone-black"></div>
                            <!-- 任务名称 -->
                            <span class="row-task-name-text" :data-type="scope.row.type" @click="renameTaskPopup(scope.row)">{{ scope.row.name }}</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- 任务来源栏 -->
                <el-table-column :label="$t('language.common.from')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="row-task-from-to">
                            <!-- 源云盘图标 -->
                            <div :class="'row-drive-icon drive-icon-' + getDrive(scope.row.fdid).type"></div>
                            <el-tooltip effect="light" placement="bottom" :disabled="scope.row.param.from==null">
                                <!-- 源云盘路径 -->
                                <template slot="content">
                                    <el-breadcrumb class="folder-nav" separator-class="el-icon-arrow-right">
                                        <el-breadcrumb-item v-for="node in getNodeArr(scope.row.param.from)" :key="node.id">
                                            <span :class="'folder-nav-span ' + (node.dir?'folder':'file')" @click="openFolder(scope.row.fdid, node, null)">{{ node.name }}</span>
                                        </el-breadcrumb-item>
                                    </el-breadcrumb>
                                </template>
                                <!-- 源云盘名称 -->
                                <div class="task-from-to" @click="openFolder(scope.row.fdid, null, null)">{{ getDrive(scope.row.fdid).name }}</div>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <!-- 任务目标栏 -->
                <el-table-column :label="$t('language.common.to')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="row-task-from-to">
                            <!-- 目标云盘图标 -->
                            <div :class="'row-drive-icon drive-icon-' + getDrive(scope.row.tdid).type"></div>
                            <el-tooltip effect="light" placement="bottom" :disabled="scope.row.param.to==null">
                                <!-- 目标路径 -->
                                <template slot="content">
                                    <el-breadcrumb class="folder-nav" separator-class="el-icon-arrow-right">
                                        <el-breadcrumb-item v-for="node in getNodeArr(scope.row.param.to)" :key="node.id">
                                            <span :class="'folder-nav-span ' + (node.dir?'folder':'file')" @click="openFolder(scope.row.tdid, node, null)">{{ node.name }}</span>
                                        </el-breadcrumb-item>
                                    </el-breadcrumb>
                                </template>
                                <!-- 目标云盘名称 -->
                                <div class="task-from-to" @click="openFolder(scope.row.tdid, null, null)">{{ getDrive(scope.row.tdid).name }}</div>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <!-- 任务计划栏 -->
                <el-table-column :label="$t('language.popup.cloudTransferPopup.schedule')" show-overflow-tooltip> 
                    <template slot-scope="scope">
                        <div class="task_cron row_task_cron">
                            <span v-if="scope.row.param.options.cron=='0 */5 * * * ?'" @click="taskOptionsPopup(scope.row)" class="real-sync">
                                <i class="el-icon-loading"></i>
                                <span>{{ $t('language.cloudSync.realSyncing') }}</span>
                            </span>
                            <tabTaskSchdule v-else-if="scope.row.type!='copy'&&scope.row.param.options.schedules" :task="scope.row.param.options" @update="switchSchedule(scope.row)" @open-popup="editSchedule(scope.row)"></tabTaskSchdule>
                        </div>
                    </template>
                </el-table-column>
                <!-- 任务状态栏 -->
                <el-table-column :label="$t('language.common.status')" show-overflow-tooltip width="180px">
                    <template slot-scope="scope">
                        <div class="row-task-status task-status" :data-status="scope.row.status">
                            <!-- 任务状态图标 -->
                            <i v-if="scope.row.status == 'create'" class="el-icon-circle-plus"></i>
                            <i v-if="scope.row.status == 'pending'" class="el-icon-magic-stick"></i>
                            <i v-if="scope.row.status == 'running'" class="el-icon-loading"></i>
                            <i v-if="scope.row.status == 'cancelled'" class="el-icon-remove"></i>
                            <i v-if="scope.row.status == 'completed'" class="el-icon-success"></i>
                            <i v-if="scope.row.status == 'failed'" class="el-icon-error"></i>
                            <i v-if="scope.row.status == 'warn'" class="el-icon-warning"></i>
                            <i v-if="scope.row.status == 'error'" class="el-icon-s-release"></i>
                            <!-- 状态 -->
                            <span @click="showTaskDetail(scope.row)" class="task-status-text">{{ $t('language.popup.'+scope.row.status+'TaskStatus') }}</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- 任务操作栏 -->
                <el-table-column v-if="activeName!='copy'" :label="$t('language.common.operate')" width="130px">
                    <template slot-scope="scope">
                        <div class="row-task-options" v-if="scope.row.type!='copy'">
                            <div v-if="!isRun(scope.row.status)" @click="startTask(scope.row.id)" class="task_start"></div>
                            <div v-if="!isRun(scope.row.status)" @click.stop="showTaskMoreMenu(scope.row.id)" class="task_more"></div>
                            <div v-if="isRun(scope.row.status)" @click="cancelTask(scope.row.id)" class="task_stop"></div>
                            <div class="task_mores" v-show="!isRun(scope.row.status) && taskMoreMenuId==scope.row.id">
                                <div @click="showTaskDetail(scope.row)" class="task_logs">{{$t('language.popup.taskListPopup.viewLogs')}}</div>
                                <div @click="taskRestorePopup(scope.row)" class="task_restore" v-if="scope.row.type=='backup' || scope.row.type=='website'">{{$t('language.cloudBackup.restore')}}</div>
                                <div @click="taskOptionsPopup(scope.row)" class="task_options">{{$t('language.common.options')}}</div>
                                <div @click="deleteTaskPopup(scope.row)" class="task_delete">{{$t('language.common.delete')}}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 单个任务: 盒子模式 -->
            <div v-if="activeView=='box'" class="task-item" v-for="task in filterTasks" :key="task.id">
                <!-- 任务类型和名称 -->
                <div class="task-type">
                    <!-- 任务类型图标 -->
                    <div v-if="task.type == 'copy'" class="cloudTransfer-black"></div>
                    <div v-if="task.type == 'tran'" class="cloudTransfer-black"></div>
                    <div v-if="task.type == 'sync'" class="cloudsync-black"></div>
                    <div v-if="task.type == 'backup'" class="cloudbackup-black"></div>
                    <div v-if="task.type == 'restore'" class="restoreTask-black"></div>
                    <div v-if="task.type == 'website'" class="liteWebsite-black"></div>
                    <div v-if="task.type == 'clone'" class="liteClone-black"></div>
                    <!-- 任务名称 -->
                    <span :data-type="task.type" @click="renameTaskPopup(task)">{{ task.name }}</span>
                </div>
                <!-- 任务计划 -->
                <div class="task_cron">
                    <span v-if="task.param.options.cron=='0 */5 * * * ?'" @click="taskOptionsPopup(task)" class="real-sync">
                        <i class="el-icon-loading"></i>
                        <span>{{ $t('language.cloudSync.realSyncing') }}</span>
                    </span>
                    <tabTaskSchdule v-else-if="task.type!='copy'&&task.param.options.schedules" :task="task.param.options" @update="switchSchedule(task)" @open-popup="editSchedule(task)"></tabTaskSchdule>
                </div>
                <!-- 任务来源和目标 -->
                <div style="height:80px;margin-top:30px;padding-bottom:60px;border-bottom:1px solid #d3dcf0;">
                    <el-row :gutter="20">
                        <!-- 来源 -->
                        <el-col :span="8" style="display:flex;justify-content:right;align-items:center;">
                            <div style="text-align:center;">
                                <!-- 源云盘图标 -->
                                <div :class="'drive-icon-' + getDrive(task.fdid).type"
                                    style="width:60px;height:60px;margin:0 auto;"></div>
                                <el-tooltip effect="light" placement="bottom" :disabled="task.param.from==null">
                                    <!-- 源云盘路径 -->
                                    <template slot="content">
                                        <el-breadcrumb class="folder-nav" separator-class="el-icon-arrow-right">
                                            <el-breadcrumb-item v-for="node in getNodeArr(task.param.from)" :key="node.id">
                                                <span :class="'folder-nav-span ' + (node.dir?'folder':'file')" @click="openFolder(task.fdid, node, null)">{{ node.name }}</span>
                                            </el-breadcrumb-item>
                                        </el-breadcrumb>
                                    </template>
                                    <!-- 源云盘名称 -->
                                    <div class="task-from-to" @click="openFolder(task.fdid, null, null)">{{ getDrive(task.fdid).name }}</div>
                                </el-tooltip>
                            </div>
                        </el-col>
                        <!-- 任务中间的图标 -->
                        <el-col :span="8" style="display:flex;justify-content:center;align-items:center;">
                            <div class="task-center-icon" :data-type="task.type">
                                <div v-if="task.type == 'copy'" class="double_arrow"></div>
                                <div v-if="task.type == 'tran'" class="double_arrow"></div>
                                <div v-if="task.type == 'sync'" :class="task.param.options.syncMode=='two' ? 'sync_arrow' : 'double_arrow'"></div>
                                <div v-if="task.type == 'backup'" class="double_arrow"></div>
                                <div v-if="task.type == 'restore'" class="double_arrow"></div>
                                <div v-if="task.type == 'website'" class="double_arrow"></div>
                                <div v-if="task.type == 'clone'" class="double_arrow"></div>
                            </div>
                        </el-col>
                        <!-- 目标 -->
                        <el-col :span="8" style="display:flex;justify-content:left;align-items:center;">
                            <div style="text-align:center;">
                                <!-- 目标云盘图标 -->
                                <div :class="'drive-icon-' + getDrive(task.tdid).type"
                                    style="width:60px;height:60px;margin:0 auto;"></div>
                                <el-tooltip effect="light" placement="bottom" :disabled="task.param.to==null">
                                    <!-- 目标路径 -->
                                    <template slot="content">
                                        <el-breadcrumb class="folder-nav" separator-class="el-icon-arrow-right">
                                            <el-breadcrumb-item v-for="node in getNodeArr(task.param.to)" :key="node.id">
                                                <span :class="'folder-nav-span ' + (node.dir?'folder':'file')" @click="openFolder(task.tdid, node, null)">{{ node.name }}</span>
                                            </el-breadcrumb-item>
                                        </el-breadcrumb>
                                    </template>
                                    <!-- 目标云盘名称 -->
                                    <div class="task-from-to" @click="openFolder(task.tdid, null, null)">{{ getDrive(task.tdid).name }}</div>
                                </el-tooltip>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style="margin-top: 10px;">
                    <el-row :gutter="10">
                        <el-col :span="18">
                            <!-- 任务状态 -->
                            <div class="task-status" :data-status="task.status">
                                <i v-if="task.status == 'create'" class="el-icon-circle-plus"></i>
                                <i v-if="task.status == 'pending'" class="el-icon-magic-stick"></i>
                                <i v-if="task.status == 'running'" class="el-icon-loading"></i>
                                <i v-if="task.status == 'cancelled'" class="el-icon-remove"></i>
                                <i v-if="task.status == 'completed'" class="el-icon-success"></i>
                                <i v-if="task.status == 'failed'" class="el-icon-error"></i>
                                <i v-if="task.status == 'warn'" class="el-icon-warning"></i>
                                <i v-if="task.status == 'error'" class="el-icon-s-release"></i>
                                <span @click="showTaskDetail(task)">
                                    <span class="task-status-text">{{ $t('language.popup.'+task.status+'TaskStatus') }}</span>
                                    <span class="task-line-info">{{ taskLineInfo(task) }}</span>
                                    <div @click.stop="showUpgrad()" class="speed-up-btn" v-if="!isVIP && task.status == 'running'">
                                        <img src="@/assets/images/vectorImg/speed_up.svg">
                                        <div class="speed-up-txt">{{$t('language.taskList.speedUP')}}</div>
                                    </div>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <!-- 操作任务的按钮 -->
                            <div class="task_action" v-if="task.type!='copy'">
                                <div v-if="!isRun(task.status)" @click="startTask(task.id)" class="task_start"></div>
                                <div v-if="!isRun(task.status)" @click.stop="showTaskMoreMenu(task.id)" class="task_more"></div>
                                <div v-if="isRun(task.status)" @click="cancelTask(task.id)" class="task_stop"></div>
                                <div class="task_mores" v-show="!isRun(task.status) && taskMoreMenuId==task.id">
                                    <div @click="showTaskDetail(task)" class="task_logs">{{$t('language.popup.taskListPopup.viewLogs')}}</div>
                                    <div @click="taskRestorePopup(task)" class="task_restore" v-if="task.type=='backup' || task.type=='website'">{{$t('language.cloudBackup.restore')}}</div>
                                    <div @click="taskOptionsPopup(task)" class="task_options">{{$t('language.common.options')}}</div>
                                    <div @click="deleteTaskPopup(task)" class="task_delete">{{$t('language.common.delete')}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 当前任务 -->
        <div class="lite_popup task_info" v-if="curTask && showCurTask">
            <div class="lite_popup_box">
                <div class="lite_popup_title">
                    <span>{{$t('language.popup.viewLogsPopup.title')}} {{ curTask.name }}</span>
                    <div class="icon white-close dialog-close" @click="showCurTask = false"></div>
                </div>
                <div class="lite_popup_content lite-task-datail">
                    <!-- 状态 -->
                    <div class="task-status" :data-status="curTask.status" style="text-align:center;">
                        <i v-if="curTask.status == 'create'" class="el-icon-circle-plus"></i>
                        <i v-if="curTask.status == 'pending'" class="el-icon-magic-stick"></i>
                        <i v-if="curTask.status == 'running'" class="el-icon-loading"></i>
                        <i v-if="curTask.status == 'cancelled'" class="el-icon-remove"></i>
                        <i v-if="curTask.status == 'completed'" class="el-icon-success"></i>
                        <i v-if="curTask.status == 'failed'" class="el-icon-error"></i>
                        <i v-if="curTask.status == 'warn'" class="el-icon-warning"></i>
                        <i v-if="curTask.status == 'error'" class="el-icon-s-release"></i>
                        <el-tooltip effect="light" placement="bottom">
                            <template slot="content">
                                <div class="cur_task_msg">
                                    <span><b>Task Msg:</b> {{ curTask.msg }}</span>
                                </div>
                                <div class="cur_task_msg" v-if="curTask.result.curMsg">
                                    <span><b>Cur Msg:</b> {{ curTask.result.curMsg }}</span>
                                </div>
                                <div class="cur_task_msg" v-if="curTask.result.curNode">
                                    <div>
                                        <span><b>Cur Node:</b> {{ getNodePath(curTask.result.curNode) }}</span>
                                    </div>
                                    <div>
                                        <span><b>Cur Node Msg:</b> {{ curTask.result.curNode.msg }}</span>
                                    </div>
                                </div>
                            </template>
                            <span class="task-status-text">{{ $t('language.popup.'+curTask.status+'TaskStatus') }} {{ taskLineInfo(curTask) }}</span>
                        </el-tooltip>
                    </div>
                    <!-- 5项数据：同步任务 -->
                    <div v-if="curTask.type=='sync'" style="margin:30px 0px;text-align: center;">
                        <!-- 错误数量 -->
                        <div style="text-align:center;display: inline-block;margin: 0 10px;" v-if="hasErrors(curTask)">
                            <div style="margin-bottom:5px;color:#f65d58;"><b>{{ (curTask.result.countWarn + curTask.result.countError) }}</b></div>
                            <span style="color:#f65d58;">{{$t('language.popup.viewLogsPopup.errorNum')}}</span>
                        </div>
                        <!-- 新增数量 -->
                        <div v-if="hasErrors(curTask)" class="size_line" style="margin-left:35px;margin-right:35px;display: inline-block;"></div>
                        <div style="text-align:center;color: #606266;display: inline-block;margin: 0 10px;">
                            <div style="margin-bottom:5px;"><b>{{ (curTask.result.countAdd) }}</b></div>
                            <span>{{$t('language.popup.viewLogsPopup.addNum')}}</span>
                        </div>
                        <!-- 更新数量 -->
                        <div class="size_line" style="margin-left:35px;margin-right:35px;display: inline-block;"></div>
                        <div style="text-align:center;color: #606266;display: inline-block;margin: 0 10px;">
                            <div style="margin-bottom:5px;"><b>{{ (curTask.result.countUpdate) }}</b></div>
                            <span>{{$t('language.popup.viewLogsPopup.updateNum')}}</span>
                        </div>
                        <!-- 删除数量 -->
                        <div class="size_line" style="margin-left:35px;margin-right:35px;display: inline-block;"></div>
                        <div style="text-align:center;color: #606266;display: inline-block;margin: 0 10px;">
                            <div style="margin-bottom:5px;"><b>{{ (curTask.result.countDelete) }}</b></div>
                            <span>{{$t('language.popup.viewLogsPopup.deleteNum')}}</span>
                        </div>
                        <!-- 大小 -->
                        <div class="size_line" style="margin-left:35px;margin-right:35px;display: inline-block;"></div>
                        <div style="text-align:center;color: #606266;display: inline-block;margin: 0 10px;">
                            <div style="margin-bottom:5px;"><b>{{ formatBytes(curTask.result.sizeCur) }}</b></div>
                            <el-tooltip effect="light" placement="bottom">
                                <template slot="content">
                                    <div>{{ avgSpeed(curTask.result.startTime, curTask.result.endTime, curTask.result.sizeCur) }}</div>
                                </template>
                                <span>{{$t('language.popup.viewLogsPopup.syncSize')}}</span>
                            </el-tooltip>
                        </div>
                        <!-- 时间 -->
                        <div class="size_line" style="margin-left:35px;margin-right:35px;display: inline-block;"></div>
                        <div style="text-align:center;color: #606266;display: inline-block;margin: 0 10px;">
                            <div style="margin-bottom:5px;"><b>{{ formatTime(curTask.result.endTime - curTask.result.startTime) }}</b></div>
                            <span>{{$t('language.popup.viewLogsPopup.syncTime')}}</span>
                        </div>
                    </div>
                    <!-- 3项数据：其他任务 -->
                    <el-row v-else :gutter="20" style="margin:30px 0px;">
                        <!-- 个数 -->
                        <el-col :span="hasErrors(curTask)?12:10" style="display:flex;justify-content:right;align-items:center;">
                            <div style="text-align:center;" v-if="hasErrors(curTask)">
                                <div style="margin-bottom:5px;color:#f65d58;"><b>{{ (curTask.result.countWarn + curTask.result.countError) }}</b></div>
                                <span style="color:#f65d58;">{{$t('language.popup.viewLogsPopup.errorNum')}}</span>
                            </div>
                            <div class="size_line" style="margin-left:35px;margin-right:35px;" v-if="hasErrors(curTask)"></div>
                            <div style="text-align:center;color: #606266;">
                                <div style="margin-bottom:5px;"><b>{{ (curTask.result.countSuccess) }}</b></div>
                                <el-tooltip effect="light" placement="bottom">
                                    <template slot="content">
                                        <span>{{ countTitle(curTask.result) }}</span>
                                    </template>
                                    <span>
                                        <span v-if="curTask.type=='website'">{{$t('language.popup.viewLogsPopup.backupNum')}}</span>
                                        <span v-else-if="curTask.type=='backup'">{{$t('language.popup.viewLogsPopup.backupNum')}}</span>
                                        <span v-else-if="curTask.type=='restore'">{{$t('language.popup.viewLogsPopup.restoreNum')}}</span>
                                        <span v-else>{{$t('language.popup.viewLogsPopup.tranNum')}}</span>
                                    </span>
                                </el-tooltip>
                            </div>
                        </el-col>
                        <!-- 大小 -->
                        <el-col :span="4" style="display:flex;justify-content:center;align-items:center;">
                            <div class="size_line" style="margin-right:35px;"></div>
                            <div style="text-align:center;color: #606266;">
                                <div style="margin-bottom:5px;"><b>{{ formatBytes(curTask.result.sizeCur) }}</b></div>
                                <el-tooltip effect="light" placement="bottom">
                                    <template slot="content">
                                        <div>{{ avgSpeed(curTask.result.startTime, curTask.result.endTime, curTask.result.sizeCur) }}</div>
                                    </template>
                                    <span>
                                        <span v-if="curTask.type=='website'">{{$t('language.popup.viewLogsPopup.backupSize')}}</span>
                                        <span v-else-if="curTask.type=='backup'">{{$t('language.popup.viewLogsPopup.backupSize')}}</span>
                                        <span v-else-if="curTask.type=='restore'">{{$t('language.popup.viewLogsPopup.restoreSize')}}</span>
                                        <span v-else>{{$t('language.popup.viewLogsPopup.tranSize')}}</span>
                                    </span>
                                </el-tooltip>
                            </div>
                            <div class="size_line" style="margin-left:35px;"></div>
                        </el-col>
                        <!-- 时间 -->
                        <el-col :span="hasErrors(curTask)?8:10" style="display:flex;justify-content:left;align-items:center;">
                            <div style="text-align:center;color: #606266;">
                                <div style="margin-bottom:5px;"><b>{{ formatTime(curTask.result.endTime - curTask.result.startTime) }}</b></div>
                                <span>
                                    <span v-if="curTask.type=='website'">{{$t('language.popup.viewLogsPopup.backupTime')}}</span>
                                    <span v-else-if="curTask.type=='backup'">{{$t('language.popup.viewLogsPopup.backupTime')}}</span>
                                    <span v-else-if="curTask.type=='restore'">{{$t('language.popup.viewLogsPopup.restoreTime')}}</span>
                                    <span v-else>{{$t('language.popup.viewLogsPopup.tranTime')}}</span>
                                </span>
                            </div>
                        </el-col>
                    </el-row>
                    <!-- 任务来源目标信息 -->
                    <div class="lite_task_detail" v-if="['create','pending','completed'].includes(curTask.status) || (curTask.status=='cancelled' && !curTask.errors)">
                        <!-- 标题栏 -->
                        <div class="lite_task_detail_title">
                            <b>{{$t('language.popup.viewLogsPopup.to')}}</b>
                            <!-- 目标 -->
                            <span class="lite_task_detail_to_path">
                                <!-- 目标云盘 -->
                                <span class="lite_task_detail_node" @click="openFolder(curTask.tdid, null, null)">{{ getDrive(curTask.tdid).name }}</span>
                                <!-- 目标节点 -->
                                <span v-for="node in getNodeArr(curTask.param.to)" :key="node.id">
                                    <span>/<span @click="openFolder(curTask.tdid, node, null)" :class="'lite_task_detail_node' + (node.dir?' node-folder':'node-file')">{{ node.name }}</span></span>
                                </span>
                            </span>
                            <!-- 执行时间 -->
                            <span class="lite_task_detail_title_time">
                                <span>{{$t('language.popup.viewLogsPopup.executeTime')}}</span>
                                <span>{{ formatDate(curTask.result.startTime) }} - {{ formatDate(curTask.result.endTime) }}</span>
                            </span>
                        </div>
                        <!-- 来源标题栏 -->
                        <div class="lite_task_detail_title_from">
                            <div class="lite_sub_title">{{$t('language.common.from')}}</div>
                            <div class="lite_sub_title lite_sub_title_big">{{$t('language.common.fileProcess')}}</div>
                            <div class="lite_sub_title lite_sub_title_small">{{$t('language.common.dataProcess')}}</div>
                            <div class="lite_sub_title lite_sub_title_small">{{$t('language.popup.viewLogsPopup.tranTime')}}</div>
                            <div class="lite_sub_title lite_sub_title_small">{{$t('language.popup.viewLogsPopup.executeResult')}}</div>
                        </div>
                        <div class="lite_task_detail_from">
                            <div class="lite_sub_title lite_task_detail_fromn_path">
                                <span class="lite_task_detail_node" @click="openFolder(curTask.fdid, null, null)">{{ getDrive(curTask.fdid).name }}</span>
                                <span v-for="node in getNodeArr(curTask.param.from)" :key="node.id">
                                    <span>/<span @click="openFolder(curTask.fdid, node, null)" :class="'lite_task_detail_node' + (node.dir?' node-folder':'node-file')">{{ node.name }}</span></span>
                                </span>
                            </div>
                            <div class="lite_sub_title lite_sub_title_big">
                                <span v-if="curTask.type=='sync'">
                                    <el-tooltip effect="light" placement="bottom">
                                        <template slot="content">
                                            <span>{{ countTitle(curTask.result) }}</span>
                                        </template>
                                        <span>{{$t('language.popup.viewLogsPopup.add')+curTask.result.countAdd+" "+$t('language.popup.viewLogsPopup.update')+curTask.result.countUpdate+" "+$t('language.popup.viewLogsPopup.delete')+curTask.result.countDelete}}</span>
                                    </el-tooltip>
                                </span>
                                <span v-else>{{ (curTask.result.countSuccess) + ' / ' + (curTask.result.countSum) }}</span>
                            </div>
                            <div class="lite_sub_title lite_sub_title_small">{{ formatBytes(curTask.result.sizeCur) + ' / ' + formatBytes(curTask.result.sizeSum) }}</div>
                            <div class="lite_sub_title lite_sub_title_small">{{ formatTime(curTask.result.endTime - curTask.result.startTime) }}</div>
                            <div class="lite_sub_title lite_sub_title_small">{{ $t('language.popup.'+curTask.status+'TaskStatus') }}</div>
                        </div>
                    </div>
                    <!-- 正在执行的节点 -->
                    <el-table class="lite-table-running" v-if="curTask.status == 'running'" :data="curTask.result.runningFiles" border highlight-current-row height="428px" empty-text=" ">
                        <el-table-column type="index" width="50"></el-table-column>
                        <el-table-column :label="$t('language.common.transferFiles')" show-overflow-tooltip width="860px">
                            <template slot-scope="scope">
                                <span>{{ getNodePath(scope.row) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('language.common.status')" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <img @click="showUpgrad()" class="thread_lock" v-if="scope.row.msg=='lock'" src="../../assets/images/task-icon/progress_lock.svg" draggable="false" />
                                <span v-else>{{ scope.row.msg }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 加载中 -->
                    <div class="lite-error-loading" v-show="loadingErrorFiles"></div>
                    <!-- 错误列表 -->
                    <el-table class="lite-table-error" v-if="curTask.errors && isDone(curTask.status)" :data="curTask.errors" border highlight-current-row height="428px" empty-text=" ">
                        <el-table-column type="index" width="50"></el-table-column>
                        <el-table-column :label="$t('language.common.transferFiles')" show-overflow-tooltip width="400px">
                            <template slot-scope="scope">
                                <i v-if="scope.row.dir" class="el-icon-folder"></i>
                                <i v-else class="el-icon-document"></i>
                                <span>{{ getNodePath(scope.row) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('language.common.size')" width="100px">
                            <template slot-scope="scope">
                                {{ formatBytes(scope.row.size) }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('language.popup.warning')" width="120px">
                            <template slot-scope="scope">
                                {{ scope.row.warn }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('language.popup.detailed')" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.msg }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('language.popup.logs')" width="100px">
                            <template slot-scope="scope">
                                <span @click="traceInfo = scope.row.trace" class="show-trace">{{ $t('language.imageSaver.view') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 堆栈信息 -->
                    <pre v-if="traceInfo" class="trace-info">{{ traceInfo }}</pre>
                    <!-- 关闭堆栈信息 -->
                    <el-button v-if="traceInfo" @click="traceInfo = null" size="small" circle class="trace-close">
                        <i class="el-icon-close"></i>
                    </el-button>
                </div>
            </div>
        </div>
        <!-- 重命名 -->
        <liteInput ref="inputPopup" :data="input_popup_data" @ok="inputPopupOK" />
        <!-- 确认弹窗 -->
        <liteConfirm ref="confirmPopup" :data="confirm_popup_data" @ok="confirmPopupOK" />
        <!-- 修改配置 -->
        <liteOptions ref="taskOptions" :data="curTaskOptions" @ok="okOptions" />
        <!-- 还原配置 -->
        <liteRestore ref="taskRestore" :data="curTaskRetore" @ok="okRestore" />
        <!-- 计划弹窗 -->
        <transferScheduleDialog ref="transferScheduleDialog" :schedules=pSchedules></transferScheduleDialog>
        <!-- 升级弹窗 -->
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    </div>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import commonUtils from "@/js/workspace/common_util.js";
import liteInput from '@/components/workspace/lite_input.vue';
import liteConfirm from '@/components/workspace/lite_confirm.vue';
import liteOptions from "@/components/workspace/lite_options";
import liteRestore from "@/components/workspace/lite_restore";
import tabTaskSchdule from "@/components/common/tabs/tabs_task_list/tab_task_schdule";
import transferScheduleDialog from "@/components/popup/cloud_transfer_popups/task_schedule_popup";
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";

export default {
    components: {
        liteInput,
        liteConfirm,
        liteOptions,
        liteRestore,
        tabTaskSchdule,
        transferScheduleDialog,
        upgradeNewDialog,
    },
    watch: {
        taskStatusAll(val) {
            if (val) {
                this.taskStatus.create = true;
                this.taskStatus.pending = true;
                this.taskStatus.running = true;
                this.taskStatus.cancelled = true;
                this.taskStatus.completed = true;
                this.taskStatus.failed = true;
                this.taskStatus.warn = true;
                this.taskStatus.error = true;
            } else {
                this.taskStatus.create = false;
                this.taskStatus.pending = false;
                this.taskStatus.running = false;
                this.taskStatus.cancelled = false;
                this.taskStatus.completed = false;
                this.taskStatus.failed = false;
                this.taskStatus.warn = false;
                this.taskStatus.error = false;
            }
        },
        pSchedules(newVal) {
            let options = this.pSchTask.param.options;
            if (options.schedules != newVal) {
                options.schedules = newVal;
                options.schedules.disabled = false;
                this.optionsTask(this.pSchTask.id, options);
            }
        },
    },
    data() {
        return {
            pSchTask: null,
            pSchedules: null,
            taskMoreMenuId: '',
            loadingAllTask: false,
            loadingErrorFiles: false,
            isVIP: commonUtils.getUser().vip,
            activeView: localStorage.getItem('lite_task_view_' + commonUtils.getUser().id) || 'box',
            activeName: 'all',
            multipleSelection: [],
            taskStatusAll: true,
            taskStatus: {
                create: true,
                pending: true,
                running: true,
                cancelled: true,
                completed: true,
                failed: true,
                warn: true,
                error: true,
            },
            // 任务进度定时器
            taskTimer: null,
            // 当前任务
            curTask: null,
            // 显示当前任务详情
            showCurTask: false,
            // 堆栈信息
            traceInfo: null,
            // 输入框弹窗
            input_popup_data: {
                id: '',
                type: '',
                title: '',
                value: '',
                placeholder: '',
            },
            // 确认弹窗
            confirm_popup_data: {
                id: '',
                type: '',
                title: '',
                desc: '',
            },
            // 还原任务
            curTaskRetore: null,
            // 当前任务配置
            curTaskOptions: {
                id: '',
                listThread: 1,
                runThread: 1,
                email: '',
                cron: '',
                sameName: '',
                excludeNames: [],
                allowedExtensions: [],
                type: '',
                onlyAdd: false,
                schedules: {disabled:true},
                delete: false,
                keepDate: false,
                logFile: false,
                inOneFolder: false,
                syncMode: '',
            },
        }
    },
    computed: {
        hasRunTask() {
            return this.$store.state.tasks.filter(task => (task.status=='pending'||task.status=='running')).length > 0;
        },
        copyTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'copy').length;
        },
        tranTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'tran').length;
        },
        syncTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'sync').length;
        },
        backupTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'backup').length;
        },
        restoreTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'restore').length;
        },
        websiteTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'website').length;
        },
        cloneTaskCount() {
            return this.$store.state.tasks.filter(task => task.type === 'clone').length;
        },
        filterTasks() {
            const type = this.activeName;
            if (['copy', 'tran', 'sync', 'backup', 'restore', 'website', 'clone'].includes(type)) {
                return this.$store.state.tasks.filter(task => {
                    const status = task.status;
                    if (!this.taskStatus.create && status == 'create') return false;
                    if (!this.taskStatus.pending && status == 'pending') return false;
                    if (!this.taskStatus.running && status == 'running') return false;
                    if (!this.taskStatus.cancelled && status == 'cancelled') return false;
                    if (!this.taskStatus.completed && status == 'completed') return false;
                    if (!this.taskStatus.failed && status == 'failed') return false;
                    if (!this.taskStatus.warn && status == 'warn') return false;
                    if (!this.taskStatus.error && status == 'error') return false;
                    return task.type === type;
                });
            } else {
                return this.$store.state.tasks.filter(task => {
                    const status = task.status;
                    if (!this.taskStatus.create && status == 'create') return false;
                    if (!this.taskStatus.pending && status == 'pending') return false;
                    if (!this.taskStatus.running && status == 'running') return false;
                    if (!this.taskStatus.cancelled && status == 'cancelled') return false;
                    if (!this.taskStatus.completed && status == 'completed') return false;
                    if (!this.taskStatus.failed && status == 'failed') return false;
                    if (!this.taskStatus.warn && status == 'warn') return false;
                    if (!this.taskStatus.error && status == 'error') return false;
                    return true;
                });
            }
        },
    },
    mounted() {
        // 初始化，加载任务信息
        this.loadingAllTask = true;
        this.listTasks(() => {
            this.taskTimer = setInterval(() => {
                if (this.$store.state.isLiteMode) {
                    if (this.$route.path=='/mc_project/task_list' || this.hasRunTask) {
                        this.loadTaskProg();
                    }
                }
            }, 3000);
            setTimeout(() => {
                this.checkAddCloudResult();
            }, 1000)
            this.loadingAllTask = false;
        });
        document.addEventListener('click', () => {
            this.taskMoreMenuId = '';
        });
    },
    beforeDestroy() {
        if (this.taskTimer) {
            clearInterval(this.taskTimer);
            this.taskTimer = null;
        }
    },
    methods: {
        showUpgrad() {
            this.showCurTask = false
            var upgradeNewDialog = this.$refs.upgradeNewDialog;
            upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_speed');
            upgradeNewDialog.curItem = 'speed';
            upgradeNewDialog.isShow = true;
        },
        switchSchedule(task) {
            if (task.param.options.schedules.clientTime) {
                // 启用或禁用计划
                let options = task.param.options;
                options.schedules.disabled = !options.schedules.disabled;
                this.optionsTask(task.id, options);
            } else {
                // 修改计划弹窗
                this.editSchedule(task);
            }
        },
        // 修改计划弹窗
        editSchedule(task) {
            this.pSchTask = task;
            this.pSchedules = task.param.options.schedules;
            this.$refs.transferScheduleDialog.initPopup();
            this.$refs.transferScheduleDialog.taskSchduleShow = true;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        selectView(type) {
            this.activeView = type;
            let user = commonUtils.getUser();
            localStorage.setItem('lite_task_view_' + user.id, type);
            this.multipleSelection = [];
        },
        selectTab(type) {
            this.activeName = type;
            if (type == 'copy') {
                this.$store.state.liteFileTaskCountCopy = 0;
            } else if (type == 'tran') {
                this.$store.state.liteFileTaskCountTran = 0;
            } else if (type == 'sync') {
                this.$store.state.liteFileTaskCountSync = 0;
            } else if (type == 'backup') {
                this.$store.state.liteFileTaskCountBackup = 0;
            } else if (type == 'restore') {
                this.$store.state.liteFileTaskCountRestore = 0;
            } else if (type == 'website') {
                this.$store.state.liteFileTaskCountWebsite = 0;
            } else if (type == 'clone') {
                this.$store.state.liteFileTaskCountClone = 0;
            }
        },
        taskRestorePopup(task) {
            this.curTaskRetore = task;
            this.$nextTick(() => {
                this.$refs.taskRestore.init();
            });
        },
        taskOptionsPopup(task) {
            if (task.type == 'copy') {
                return;
            }
            if(this.isRun(task.status)) {
                Message.warning("The task is in progress, please try again later.");
                return;
            }
            this.curTaskOptions = task.param.options;
            this.curTaskOptions.id = task.id;
            this.curTaskOptions.type = task.type;
            this.$nextTick(() => {
                let activeTab = '';
                if (task.type == 'tran') {
                    activeTab = 'tran';
                } else if (task.type == 'sync') {
                    activeTab = 'sync';
                } else if (task.type == 'restore') {
                    activeTab = 'restore';
                } else {
                    activeTab = 'email';
                }
                this.$refs.taskOptions.init();
                this.$refs.taskOptions.activeName = activeTab;
                this.$refs.taskOptions.show = true;
            });
        },
        okRestore() {
            if (this.activeName != 'all') {
                this.activeName = 'restore';
            }
        },
        okOptions(data) {
            this.optionsTask(this.curTaskOptions.id, data);
        },
        // 更新任务配置
        optionsTask(id, options) {
            // 有了实时同步就没有计划
            if (options.cron != '') {
                options.schedules = {disabled:true};
            }
            this.sendRequest("/task/options", { id: id, options: options }, (task) => {
                this.getTask(id).param = task.param;
            });
        },
        // 重命名任务弹窗
        renameTaskPopup(task) {
            if (task.type == 'copy') return;
            this.input_popup_data.id = task.id;
            this.input_popup_data.type = "rename";
            this.input_popup_data.title = this.$t('language.common.rename');
            this.input_popup_data.value = task.name;
            this.input_popup_data.placeholder = this.$t('language.common.taskName');
            this.$refs.inputPopup.show = true;
        },
        // 删除任务弹窗
        deleteTaskPopup(task) {
            this.confirm_popup_data.id = task.id;
            this.confirm_popup_data.type = "delete";
            this.confirm_popup_data.title = this.$t('language.popup.taskListPopup.deleteTask');
            this.confirm_popup_data.desc = this.$t('language.popup.taskListPopup.deleteSingleTask');
            this.$refs.confirmPopup.show = true;
        },
        // 确认弹窗
        async confirmPopupOK() {
            const id = this.confirm_popup_data.id;
            const type = this.confirm_popup_data.type;
            if (type == 'delete') {
                this.deleteTask(id);
            }
        },
        // 批量删除任务
        async deleteTasks() {
            if (this.multipleSelection.length > 0) {
                let ids = [];
                // 筛选出可删除的任务
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    const task = this.multipleSelection[i];
                    if (!this.isRun(task.status)) {
                        ids.push(task.id);
                    }
                }
                // 批量删除
                for (let i = 0; i < ids.length; i++) {
                    await this.deleteTask(ids[i]);
                }
                this.multipleSelection = [];
            }
        },
        // 输入框弹窗确认
        inputPopupOK() {
            const id = this.input_popup_data.id;
            const type = this.input_popup_data.type;
            const name = this.input_popup_data.value;
            if (type === "rename") {
                this.renameTask(id, name);
            }
        },
        // 重命名任务
        renameTask(id, name) {
            this.sendRequest("/task/rename", { id: id, name: name }, () => {
                this.getTask(id).name = name;
            }, () => {
                this.$refs.inputPopup.show = true;
            });
        },
        // 检查云盘添加结果
        checkAddCloudResult() {
            const resultBase64 = this.$cookies.get("authResult");
            if (resultBase64) {
                this.$cookies.remove("authResult");
                try {
                    var result = new TextDecoder().decode(Uint8Array.from(atob(resultBase64), c => c.charCodeAt(0)));
                    var json = JSON.parse(result);
                    if (json.status == "success") {
                        // 添加成功
                        var deiveId = json.data;
                        // 并且打开
                        this.openFolder(deiveId, null, null);
                    } else {
                        // 添加失败原因
                        Message.error(json.data);
                    }
                } catch (e) {
                    // 解析失败
                    Message.error(resultBase64)
                }
            }
        },
        // 任务简单信息
        taskLineInfo(task) {
            if (task.status == 'running') {
                const result = task.result;
                if (result.listDone) {
                    // 单文件
                    if (result.countSum == 1 && result.runningFiles.length == 1) {
                        const msg = result.runningFiles[0].msg;
                        if (msg) {
                            return msg;
                        }
                    }
                    // 多文件
                    let percentage = '0%'
                    if (result.countSum == 1) {
                        percentage = (result.sizeCur / result.sizeSum * 100).toFixed(2) + '%';
                    } else {
                        percentage = ((result.countSkip + result.countWarn + result.countError + result.countSuccess) / result.countSum * 100).toFixed(2) + '%';
                    }
                    const avgStr = this.avgSpeed(result.startTime, result.endTime, result.sizeCur);
                    return percentage + ' ' + avgStr;
                } else {
                    return 'Count:' + result.countSum + ' Size:' + this.formatBytes(result.sizeSum);
                }
            } else {
                return '';
            }
        },
        // 显示任务详情
        showTaskDetail(task) {
            this.curTask = task;
            if (this.hasErrors(task)) {
                this.getTaskErrors(this.curTask);
            }
            this.traceInfo = null;
            this.showCurTask = true
        },
        // 平均速度
        avgSpeed(startTime, endTime, sizeCur) {
            const duration = (endTime - startTime) / 1000
            if (duration == 0) {
                return this.formatBytes(sizeCur) + '/s'
            } else {
                return this.formatBytes(sizeCur / duration) + '/s'
            }
        },
        // 格式化时间
        formatTime(millis) {
            if (!millis || millis < 0) return "-";
            let totalSeconds = Math.floor(millis / 1000);
            const days = Math.floor(totalSeconds / (24 * 3600));
            totalSeconds %= (24 * 3600);
            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            let result = "";
            if (days > 0) result += days + "d";
            if (hours > 0) result += hours + "h";
            if (minutes > 0) result += minutes + "m";
            if (seconds > 0 || result === "") result += seconds + "s";
            return result;
        },
        // 个数title
        countTitle(result) {
            return "Skip:" + result.countSkip + ",Warn:" + result.countWarn + ",Error:" + result.countError + ",Success:" + result.countSuccess + ",Sum:" + result.countSum;
        },
        // 已完成个数
        countCur(result) {
            return result.countSkip + result.countWarn + result.countError + result.countSuccess;
        },
        // 有错误
        hasErrors(task) {
            if (this.isDone(task.status)) {
                return task.result.countWarn + task.result.countError > 0;
            }
            return false;
        },
        // 已完成
        isDone(status) {
            return status == 'cancelled' || status == 'completed' || status == 'failed' || status == 'warn' || status == 'error';
        },
        // 在运行
        isRun(status) {
            return status == 'pending' || status == 'running';
        },
        // 获取
        getTask(taskId) {
            return this.$store.state.tasks.find(task => task.id === taskId) || null;
        },
        // 加载任务进度
        loadTaskProg() {
            if (this.$store.state.tasks.length == 0) return;
            this.sendRequest("/task/progress", {}, (data) => {
                let needLoadErrorTaskId = null;
                let needRefreshUser = false;
                for (let i = 0; i < data.length; i++) {
                    let task = this.getTask(data[i].id);
                    if (task) {
                        // 如果任务状态改变，并且最终状态是完成，则标记等会刷新用户信息
                        if (!needRefreshUser && task.status!=data[i].status && this.isDone(data[i].status)) {
                            needRefreshUser = true;
                        }
                        // 当前打开了任务详情，且是当前任务，且任务状态改变，且最终状态是完成，且最终状态不是成功
                        if (this.showCurTask && this.curTask.id==task.id && task.status!=data[i].status && this.isDone(data[i].status) && data[i].status!='completed') {
                            needLoadErrorTaskId = task.id;
                        }
                        // 更新任务的：消息，状态，结果
                        task.msg = data[i].msg;
                        task.result = data[i].result;
                        task.status = data[i].status;
                    }
                }
                // 刷新用户信息
                if (needRefreshUser) {
                    commonUtils.refreshUserInfo(this.$parent, function(res) {});
                }
                // 加载任务错误文件
                if (needLoadErrorTaskId) {
                    let task = this.getTask(needLoadErrorTaskId);
                    this.showTaskDetail(task);
                }
            })
        },
        // 获取任务错误信息
        getTaskErrors(task) {
            const taskId = task.id;
            this.loadingErrorFiles = true;
            this.sendRequest("/task/errors", { id: taskId }, (data) => {
                task.errors = data;
                this.loadingErrorFiles = false;
            }, () => {
                this.loadingErrorFiles = false;
            })
        },
        // 取消任务
        cancelTask(taskId) {
            this.sendRequest("/task/cancel", { id: taskId }, () => {
                this.listTasks();
            })
        },
        // 启动任务
        startTask(taskId) {
            this.sendRequest("/task/start", { id: taskId }, () => {
                this.listTasks();
            })
        },
        // 显示任务更多操作
        showTaskMoreMenu(taskId) {
            this.taskMoreMenuId = taskId;
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        // 删除任务
        deleteTask(taskId) {
            return new Promise((resolve, reject) => {
                this.sendRequest("/task/delete", { id: taskId }, () => {
                    const index = this.$store.state.tasks.findIndex(item => item.id === taskId);
                    if (index !== -1) {
                        this.$store.state.tasks.splice(index, 1);
                        if (this.filterTasks.length==0 && this.$store.state.tasks.length!=0) {
                            this.selectTab('all');
                        }
                    }
                    resolve();
                });
            });
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '-';
            if (value === 0) return '0B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            return (value / Math.pow(k, i)).toFixed(2) + sizes[i];
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 展开文件夹
        openFolder(id, node, start) {
            if (node && !node.dir) return;
            this.$store.state.curDriveId = id;
            this.$store.state.curNode = node;
            this.$store.state.curStart = start;
            this.$store.state.needLoad = Math.random() + "";
            this.$store.commit('setleftbannerMenuClick', 108);
            this.$router.push('/mc_project/lite_file');
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errCallback) {
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        if (path != "/task/progress") {
                            Message.warning(msg);
                            if (errCallback) {
                                errCallback();
                            }
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            if (path != "/task/progress") {
                                if (!msg.includes("LiteService")) {
                                    Message.error(msg);
                                }
                                if (errCallback) {
                                    errCallback();
                                }
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    if (path != "/task/progress") {
                        Message.error(err);
                        if (errCallback) {
                            errCallback();
                        }
                    }
                });
        }
    }
}
</script>

<style scoped>
/* 按钮 */
.el-button {
    height: 40px;
}

/* Lite任务 */
.lite-task {
    padding: 20px;
    padding-top: 0px;
    padding-right: 0px;
    height: calc(100% - 20px);
}

/* 任务导航栏 */
.task-nav {
    height: 70px;
    width: calc(100% - 20px);
    position: relative;
}

/* 任务分类 */
.task-tabs {
    border-bottom: 1px solid #C1CBE3;
}

/* 任务分类项 */
.task-tab {
    height: 40px;
    line-height: 40px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    margin-right: 30px;
    display: inline-block;
    cursor: pointer;
}

/* 任务分类项:hover */
.task-tab:hover {
    color: #5562B4;
}

/* 任务分类项:选中 */
.task-tab.select {
    color: #5562B4;
    border-bottom: 4px solid #5562B4;
}

/* 任务项列表 */
.task-items {
    height: calc(100% - 50px);
    overflow: auto;
}

/* 任务项 */
.task-item {
    float: left;
    width: calc(50% - 20px);
    min-width: 500px;
    height: 355px;
    box-sizing: border-box;
    padding: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    background-color: #FFF;
    border: 1px solid #dce4f5;
    border-radius: 4px;
    box-shadow: 0 0 0 rgba(0,0,0,0);
    transition: box-shadow 0.3s ease;
}

.task-item:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

@media screen and (min-width: 1920px) and (max-width: 2368px) {
    .task-item {
        width: calc(33.33% - 20px);
    }
}

@media screen and (min-width: 2368px) {
    .task-item {
        width: calc(25% - 20px);
    }
}

/* 错误项 */
.error-item {
    padding: 10px;
    margin-top: 10px;
    border: 1px solid #dce4f5;
    max-height: 500px;
    overflow: auto;
}

.error-item pre {
    margin: 0px;
}

.task-type {
    height: 32px;
    line-height: 32px;
}

/* 任务类型图标 */
.task-type>div {
    display: inline-block;
    vertical-align: middle;
}

/* 任务名称 */
.task-type>span {
    margin-left: 10px;
    vertical-align: middle;
    font-size: 24px;
    font-weight: bold;
    display: inline-block;
    max-width: calc(100% - 40px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
}

.task-type>span[data-type='copy'] {
    cursor: default;
}

/* 任务来源目标云盘名称 */
.task-from-to {
    font-size: 14px;
    cursor: pointer;
    margin-top: 5px;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.task-from-to:hover {
    text-decoration: underline;
}

/* 任务状态 */
.task-status {
    margin-top: 20px;
    font-size: 16px;
    height: 26px;
    line-height: 26px;
}

.task-status>span:hover {
    cursor: pointer;
}

.task-status>* {
    vertical-align: middle;
}

.row-task-status {
    margin-top: 0px;
}

.task-status>i {
    font-size: 20px;
    vertical-align: middle;
    display: inline-block;
}

.lite-task-datail .task-status>i {
    font-size: 40px;
}

.task-status[data-status='create']>i { color: skyblue; }
.task-status[data-status='pending']>i { color: #999999; }
.task-status[data-status='running']>i { color: #4c64c2; }
.task-status[data-status='cancelled']>i { color: #999999; }
.task-status[data-status='completed']>i { color: #6bd96f; }
.task-status[data-status='failed']>i { color: #f65d58; }
.task-status[data-status='warn']>i { color: orange; }
.task-status[data-status='error']>i { color: #f65d58; }

.task-status .task-status-text {
    font-size: 14px;
    vertical-align: middle;
    display: inline-block;
    height: 20px;
    line-height: 20px;
}

.task-status .task-status-text:hover {
    text-decoration: underline;
}

.lite-task-datail .task-status-text {
    font-size: 28px;
    margin-left: 8px;
}

.task-status[data-status='create'] .task-status-text { color: skyblue; }
.task-status[data-status='pending'] .task-status-text { color: #303133; }
.task-status[data-status='running'] .task-status-text { color: #303133; }
.task-status[data-status='cancelled'] .task-status-text { color: #303133; }
.task-status[data-status='completed'] .task-status-text { color: #30A734; }
.task-status[data-status='failed'] .task-status-text { color: #f65d58; }
.task-status[data-status='warn'] .task-status-text { color: orange; }
.task-status[data-status='error'] .task-status-text { color: #f65d58; }

/* 任务运行简单信息 */
.task-line-info {
    font-size: 14px;
    vertical-align: middle;
    display: inline-block;
    height: 20px;
    line-height: 20px;
}

.task-line-info:hover {
    text-decoration: underline;
}

/* 显示堆栈信息 */
.show-trace {
    color: #293166;
    cursor: pointer;
}

.show-trace:hover {
    text-decoration: underline;
}

.lite-table-running,
.lite-table-error {
    margin-top: 56px;
}

/* 堆栈信息 */
.trace-info {
    position: absolute;
    z-index: 1;
    left: 20px;
    bottom: 7px;
    width: calc(100% - 40px);
    height: 450px;
    background-color: #FFF;
    border: 1px solid #C1CBE3;
    box-sizing: border-box;
    padding: 10px;
    overflow: auto;
    color: #606266;
    font-size: 14px;
}

/* 关闭堆栈信息 */
.trace-close {
    height: 34px;
    position: absolute;
    z-index: 1;
    bottom: 426px;
    right: 30px;
}

.lite_popup_box {
    width: 1200px;
}

/* 任务类型中心图标 */
.task-center-icon {
    margin-top:25px;
    font-size:30px;
    color: #8e909d;
}

.folder-nav-span {
    display: inline-block;
    vertical-align: middle;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.folder-nav-span.folder {
    width: auto;
    height: auto;
}

/* 任务源或目标文件夹导航 */
.folder-nav-span.folder:hover {
    cursor: pointer;
    text-decoration: underline;
}

/* 任务源或目标文件 */
.folder-nav-span.file:hover {
    cursor: default;
}

/* 操作任务 */
.task_action {
    text-align:right;
    float: right;
    margin-top:10px;
    display: none;
    position: relative;
    width: 110px;
}

.task-item:hover .task_action {
    display: block;
}

.row-task-options>div:hover,
.task_action>div:hover {
    background-color: #e8e8e8;
}

.row-task-options {
    height: 30px;
}

.row-task-options>div {
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-position: center;
}

/* 开始 */
.task_start {
    width: 48px;
    height: 48px;
    display: inline-block;
    background-image: url('../../assets/images/task-icon/play.svg');
    cursor: pointer;
}

/* 更多 */
.task_more {
    width: 48px;
    height: 48px;
    display: inline-block;
    background-image: url('../../assets/images/task-icon/menu.svg');
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

/* 停止 */
.task_stop {
    width: 48px;
    height: 48px;
    display: inline-block;
    background-image: url('../../assets/images/task-icon/stop.svg');
    cursor: pointer;
}

/* 更多菜单 */
.task_mores {
    border: 1px solid #8a96e3;
    background-color: #fff !important;
    position: absolute;
    z-index: 1;
    right: 30px;
    bottom: 30px;
}

.row-task-options>.task_mores {
    width: auto;
    height: auto;
    right: 90px;
    bottom: auto;
    top: 11px;
}

.task_mores>div {
    height: 35px;
    line-height: 35px;
    color: #6f7886;
    font-size: 14px;
    cursor: pointer;
    text-align: left;
    text-indent: 40px;
    background-repeat: no-repeat;
    background-size: 14px 14px;
    background-position: 20px 10px;
    padding-right: 20px;
    white-space: nowrap;
}

.task_mores>div:hover {
    background-color: #d9e7ff;
}

/* 日志 */
.task_logs {
    background-image: url('../../assets/images/vectorImg/icon_ViewLogs.svg');
}

/* 还原 */
.task_restore {
    background-image: url('../../assets/images/cloudBackup/icon_restore.svg');
}

/* 设置 */
.task_options {
    background-image: url('../../assets/images/vectorImg/icon_Options.svg');
}

/* 删除 */
.task_delete {
    background-image: url('../../assets/images/vectorImg/icon_Remove.svg');
}

/* 无任务 */
.task-none {
    height: 237px;
    width: calc(100% - 20px);
    text-align: center;
    position: absolute;
    z-index: 1;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
/* 无任务标题 */
.task-none-title {
    margin-top: 40px;
    font-size: 24px;
    color: #333333;
    font-weight: bold;
}
/* 无任务描述 */
.task-none-desc {
    margin-top: 10px;
    font-size: 16px;
    color: #6F6F6F;
}

.task-nav-right {
    position: absolute;
    z-index: 1;
    right: 0px;
    top: 0px;
}

/* 任务过滤项 */
.task-filter-status {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    border: 1px solid #5562B4;
    border-radius: 4px;
    padding: 0 10px;
    vertical-align: middle;
    margin-right: 10px;
    color: #5562B4;
    cursor: default;
}

.task-filter-status:hover {
    background-color: #5562B4;
    color: #fff;
}

/* 删除选中任务 */
.delete-select-tasks {
    display: inline-block;
    height: 30px;
    width: 30px;
    border: 1px solid #5562B4;
    border-radius: 4px;
    cursor: default;
    vertical-align: middle;
    margin-right: 10px;
    background-image: url("../../assets/images/vectorImg/icon_Remove.svg");
    background-size: 20px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
}

.delete-select-tasks:hover {
    background-color: #5562B4;
    background-image: url("../../assets/images/vectorImg/icon_Remove_dis.svg");
}

.filter-status {
    height: 30px;
    line-height: 30px;
    color: #5562B4;
    font-size: 14px;
}

.filter-status-space {
    height: 1px;
    background-color: #5562B4;
}

.task-nav-view {
    display: inline-block;
    vertical-align: middle;
}

.task-nav-view>div {
    width: 20px;
    height: 20px;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid #5562B4;
    padding: 5px 8px;
    cursor: pointer;
}

.task-nav-box {
    float: left;
    border-radius: 4px 0px 0px 4px;
    background-image: url("../../assets/images/vectorImg/icon_Switch_Thumbnail.svg");
}

.task-nav-box.select {
    background-image: url("../../assets/images/vectorImg/icon_Switch_Thumbnail_white.svg");
    background-color: #5562B4;
}

.task-nav-list {
    float: right;
    border-radius: 0px 4px 4px 0px;
    background-image: url("../../assets/images/vectorImg/icon_Switchlist.svg");
}

.task-nav-list.select {
    background-image: url("../../assets/images/vectorImg/icon_Switchlist_white.svg");
    background-color: #5562B4;
}

.row-drive-icon {
    width: 30px;
    height: 30px;
    background-size: 100%;
    display: inline-block;
    vertical-align: middle;
}

.row-task-from-to {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.row-task-from-to>.task-from-to {
    display: inline-block;
    width: auto;
    max-width: calc(100% - 40px);
    margin-top: 0px;
    vertical-align: middle;
    height: 20px;
    line-height: 22px;
}

.row-task-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.row-task-name>div {
    display: inline-block;
    vertical-align: middle;
}

.row-task-name-text {
    height: 20px;
    line-height: 20px;
    vertical-align: middle;
    font-weight: bold;
    cursor: pointer;
}

.row-task-name-text:hover {
    text-decoration: underline;
}

.row-task-name-text:hover[data-type='copy'] {
    text-decoration: none;
    cursor: default;
}

.task-list {
    min-height: calc(100% - 20px);
    width: calc(100% - 20px);
    border: 1px solid #C1CBE3;
}

.task_cron {
    height: 20px;
    line-height: 20px;
    margin-top: 20px;
}

.row_task_cron {
    margin-top: 0px;
}

.task_cron>div {
    max-width: 100%;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.lite-task-datail {
    height: 626px;
    position: relative;
}
.lite-task-datail .task-status .el-tooltip {
    cursor: default;
    text-decoration: none;
}

/* 加载中 */
.lite-tasks-loading,
.lite-error-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
}

.lite-tasks-loading {
    background: transparent;
}

/* 简洁圆环旋转动画 */
.lite-tasks-loading::after,
.lite-error-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.lite_task_detail {
    border: 1px solid #C1CBE3;
    height: 424px;
    margin-top: 60px;
}

.lite_task_detail_title {
    height: 34px;
    line-height: 34px;
    background-color: #D3DCF0;
    font-size: 14px;
    padding-left: 34px;
    padding-right: 20px;
    color: #606266;
}
.lite_task_detail_title_time {
    float: right;
    font-size: 12px;
}
.lite_task_detail_to_path {
    display: inline-block;
    max-width: 700px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    height: 32px;
    line-height: 30px;
    font-weight: bold;
}
.lite_task_detail_title_from {
    padding: 5px 0px;
    padding-left: 34px;
    border-bottom: 1px solid #D3DCF0;
    font-size: 14px;
}
.lite_sub_title {
    display: inline-block;
    width: 185px;
    border-left: 1px solid #D3DCF0;
    height: 15px;
    padding-left: 15px;
    line-height: 14px;
}
.lite_sub_title:first-child {
    border-left: none;
    width: 300px;
    padding-left: 0px;
}
.lite_task_detail_from {
    color: #606266;
    font-size: 14px;
    border-bottom: 1px solid #D3DCF0;
    padding: 22px 0px;
}
.lite_task_detail_from>.lite_sub_title {
    border-left: none;
}
.lite_task_detail_from>.lite_sub_title:first-child {
    width: 317px;
    margin-left: 20px;
}
.lite_sub_title_small {
    width: 160px;
}
.lite_sub_title_big {
    width: 260px;
}
.lite_task_detail_fromn_path {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
}
.lite_task_detail_node:hover {
    text-decoration: underline;
    cursor: pointer;
}
.node-file {
    text-decoration: none;
    cursor: default;
}
.size_line {
    width: 1px;
    height: 20px;
    background-color: #BDBDBD;
}
.size_line_white {
    width: 1px;
    height: 20px;
    background-color: #FFF;
}
.speed-up-btn {
    background: linear-gradient(172deg, #FFA133 6%, #F58427 74%);
    color: #FFFFFF;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    display: inline-block;
    padding: 0px 10px;
    border-radius: 4px;
    vertical-align: middle;
    margin-left: 5px;
}
.speed-up-btn>* {
    display: inline-block;
}
.thread_lock {
    cursor: pointer;
}
.cur_task_msg {
    max-width: 1000px;
}
.real-sync {
    cursor: pointer;
    color: #8a8c99;
    font-size: 14px;
}
.real-sync:hover>span {
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_task.vue